import React, { useState } from 'react';
import { Rating as SimpleRating } from 'react-simple-star-rating';
import { useDispatch, useSelector } from 'react-redux';
import { uniqueID } from '../../../utils/constants';
import { encodeValue } from '../../../utils/helper';
import Rating from '../../Rating';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { StarIcon } from '../../../utils/svg';
import { getOrderDetail } from '../../../store/reducers/order';

function RatingComponent({ order }) {
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);
	const [open, setOpen] = useState(false);

	return (
		<>
			<div
				onClick={() => {
					if (!!parseFloat(order?.rating)) return;
					setOpen(true);
				}}
				className='w-full flex flex-col items-center justify-center py-3 border-1 border-solid border-gray-300 rounded-md mb-6'>
				<h3 className='text-sm font-semibold mb-4'>Yuk, kasih nilai!</h3>
				<SimpleRating initialValue={parseFloat(order?.rating)} readonly transition allowFraction emptyIcon={<StarIcon className={'inline h-9 w-9'} />} fillIcon={<StarIcon className={'inline h-9 w-9'} />} />
			</div>
			<BottomSheet onDismiss={() => setOpen(false)} open={open} snapPoints={({ minHeight }) => minHeight}>
				<Rating
					order={order}
					callback={() => {
						dispatch(
							getOrderDetail({
								unquieid: uniqueID,
								customerID: encodeValue(user?.customerID),
								orderNumber: order?.orderNumber,
							}),
						);
						setOpen(false);
					}}
				/>
			</BottomSheet>
		</>
	);
}

export default RatingComponent;
